import React from 'react';
import EmptyPage from '../EmptyPage';

const AutomationRulesPage: React.FC = () => {
  return (
    <EmptyPage
      title="자동화 규칙"
      icon="Settings"
      description="업무 자동화 규칙을 설정합니다."
    />
  );
};

export default AutomationRulesPage;
